<form [formGroup]="form">
  <div class="custom-text">
    Please, choose a new password:
    <ul>
      <li>Require at least 8 characters but fewer than 99 characters</li>
      <li>Require numbers</li>
      <li>
        Require a special character from this set:
        <br>^ $ * . [ ] &#123; &#125; ( ) ? " ! @ # % & / \ , > < ' : ; | _ ~ ` = + -
      </li>
      <li>Require uppercase letters</li>
      <li>Require lowercase letters</li>
    </ul>
  </div>
  <div>
    <label for="newPassword" class="label">New password</label>
    <input id="newPassword" type="password" formControlName="password"
           class="input">
    <label for="confirmPassword" class="label">Confirm password</label>
    <input id="confirmPassword" type="password" formControlName="confirmPassword"
           class="input">
  </div>

  <div class="error-message">
    {{ errorMessage }}
  </div>

  <div class="cell-align-right">
    <button (click)="completeNewPassword()" class="vlr-primary-btn" [disabled]="!form.valid">
      Change password
    </button>
  </div>
</form>
